import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LibMarkdownModule } from '../markdown/markdown.module';
import { MentionsLegalesComponent } from './mentions-legales.component';

@NgModule({
    imports: [CommonModule, LibMarkdownModule],
    declarations: [MentionsLegalesComponent],
})
export class LibMentionsLegalesModule {
    static forRoot(): ModuleWithProviders<LibMentionsLegalesModule> {
        return {
            ngModule: LibMentionsLegalesModule,
        };
    }
}
